<template>
  <div
    :class="{ 'has-danger': error }"
    class="form-group row">
    <label class="col-4 col-form-label">Компания <span class="text-danger">*</span></label>
    <div class="col-8">
      <multiselect
        :options="companies"
        :searchable="true"
        :close-on-select="true"
        :show-labels="false"
        :value="company"
        :loading="loading"
        placeholder="Компания не выбрана"
        track-by="id"
        label="name"
        autocomplete="off"
        @open="loadCompanies"
        @input="changeCompany">
        <span slot="noResult">Компания не найдена.</span>
      </multiselect>
      <span
        v-if="error"
        class="small help-block text-danger">Компания обязательно должена быть указана</span>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import getCompanies from './../../../gql/queries/getCompanies.graphql'

export default {
  name: 'TcSelectCompany',
  components: {Multiselect},
  props: {
    value: {
      type: Number,
      default: null
    },
    company: {
      type: Object,
      default: () => {}
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      companies: [],
      loading: false
    }
  },
  methods: {
    /**
     * Подргрузка Компаний
     * активируется при открытии селекта
     */
    loadCompanies () {
      this.loadingCompanies = true
      this.$apollo.query({
        query: getCompanies,
        variables: {
          all: true
        }
      }).then(result => {
        this.companies = result.data.companies
        this.loadingCompanies = false
      }).catch(error => {
        console.log(error)
        this.loadingCompanies = false
      })
    },
    changeCompany (company) {
      this.$emit('input', company ? company.id : null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TcSelectCompany.vue?2a98acef